import { AccountSetting, useAccountSetting } from './account-settings';

/** The account's own opt-in to recording consent. */
export function useConsentRecordsEnabled(): boolean {
  return useAccountSetting(AccountSetting.ConsentRecords);
}
